<cp-app-shell>
    <router-outlet></router-outlet>
</cp-app-shell>
